import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { reducer as productReducer } from './slices/product';
import { reducer as productPartDetails } from './slices/product-part-details';
import { reducer as userReducer } from './slices/user';
import { reducer as supplierReducer } from './slices/supplier';
import { reducer as listingReducer } from './slices/listing';
import { reducer as categoryReducer } from './slices/category';
import { reducer as manufacturerReducer } from './slices/manufacturer';
import { reducer as transactionReducer } from './slices/transaction';
import { reducer as transactionPaymentReducer } from './slices/transaction-payment';
import { reducer as appReducer } from './slices/app';
import { reducer as salesReducer } from './slices/sales';
import { reducer as rmaReducer } from './slices/rma';
import { reducer as rmaInventoryReducer } from './slices/rma-inventory';
import { reducer as roleReducer } from './slices/roles';
import { reducer as permissionReducer } from './slices/permissions';
import { reducer as smsReducer } from './slices/sms';
import { reducer as auditReducer } from './slices/audit';
import { reducer as quotationReducer } from './slices/quotation';
import { reducer as quotationV2Reducer } from './slices/quotation-v2';
import { reducer as inventoryReducer } from './slices/inventory';
import { reducer as galleryReducer } from './slices/gallery';
import { reducer as ecomOrdersReducer } from './slices/ecom-orders';
import { reducer as flashDealsReducer } from './slices/flash-deals';
import { reducer as bannerReducer } from './slices/ecomm/ecomm-banner';
import { reducer as pcPackageReducer } from './slices/pc-package';
import { reducer as branchesReducer } from './slices/branches';
import { reducer as optionReducer } from './slices/option';
import { reducer as raffleReducer } from './slices/raffle';
import { reducer as pcwUserReducer } from './slices/pcw-user';
import { reducer as kachiPointsReducer } from './slices/kachi-points';
import { reducer as TransferStockReducer } from './slices/stock-transfer';
import { reducer as userBuildsReducer } from './slices/user-builds';
import { reducer as blogsReducer } from './slices/blogs';
import { reducer as blogCategoryReducer } from './slices/blog-category';
import { reducer as inventoryAuditReducer } from './slices/inventory-audit';
import { reducer as pcBundlesReducer } from './slices/pc-bundles';
import { reducer as taptapCustomerReducer } from './slices/taptap-customer';
import { reducer as locationreducer } from './slices/location';
import { reducer as promotionalReducer } from './slices/promotional';
import { reducer as favoriteReducer } from './slices/favorites';
import { reducer as recentViewedModuleReducer } from './slices/recent-visit-module';
import { reducer as fastMovingProductReducer } from './slices/fast-moving-products';
import { reducer as purchaseOrderReducer } from './slices/purchase-order';
import { reducer as taxCertificateReducer } from './slices/purchase-order/tax-certificate';
import { reducer as voucherReducer } from './slices/voucher';
import { reducer as sellOutReducer } from './slices/sell-out';
import { reducer as chequeManagementReducer } from './slices/cheque-management';
import { reducer as paymentTypeReducer } from './slices/payment';
import { reducer as eventSubscriptionsReducer } from './slices/event-subscriptions';
import { reducer as lastRouteReducer } from './slices/last-route';
import { reducer as emailerReducer } from './slices/emailer';
import { reducer as customerPaymentReducer } from './slices/customer-payment';
import { reducer as listingBundleReducer } from './slices/listing-bundle';
import { reducer as crmSalesReducer } from './slices/crm-sales';

const appConfig = {
  key: 'app',
  storage: storage,
  whitelist: ['openDrawerSectionIndices', 'isDrawerOpen']
};

const productReducerConfig = {
  key: 'products',
  storage: storage,
  whitelist: ['priceList']
};

const listingsConfig = {
  key: 'listings',
  storage: storage,
  whitelist: ['recentDRNos', 'recentPurchaseDates', 'recentSuppliers']
};

const raffleConfig = {
  key: 'raffle',
  storage: storage,
  whitelist: ['raffleWinners', 'availableRaffleEntries', 'removedRaffleWinners']
};

const inventoryAuditConfig = {
  key: 'inventory-audit',
  storage: storage,
  whitelist: ['inventoryAuditProductListing', 'commonParams']
};

const pcwUserConfig = {
  key: 'pcwUserAccount',
  storage: storage,
  whitelist: ['userAccountProfileData']
};

const taptapCustomerConfig = {
  key: 'taptapCustomer',
  storage: storage,
  whitelist: [
    'taptapVersion',
    'taptapCustomers',
    'taptapProfiles',
    'taptapColumns',
    'pendingInternalCustomer'
  ]
};

const rmaConfig = {
  key: 'rmas',
  storage: storage,
  whitelist: ['rmas', 'rmagetpayload']
};

const salesConfig = {
  key: 'sales',
  storage: storage,
  whitelist: ['salesColumns']
};

const favoriteModuleConfig = {
  key: 'favoriteModules',
  storage: storage,
  whitelist: ['favoriteModules']
};

const recentlyViewedConfig = {
  key: 'recentlyViewedModule',
  storage: storage,
  whitelist: ['recentlyViewedModule']
};

const quotationReducerConfig = {
  key: 'quotations',
  storage: storage,
  whitelist: ['productOptions']
};

const quotationV2ReducerConfig = {
  key: 'quotations-v2',
  storage: storage,
  whitelist: ['productOptions']
};

const fastMovingProductConfig = {
  key: 'fast-moving-products',
  storage: storage,
  whitelist: ['configColumn']
};

const chequeManagementConfig = {
  key: 'cheque-management',
  storage: storage,
  whitelist: ['chequeColumn']
};

const lastRouteConfig = {
  key: 'last-route',
  storage: storage,
  whitelist: ['lastRoute']
};

export const reducers = combineReducers({
  supplier: supplierReducer,
  quotation: persistReducer(quotationReducerConfig, quotationReducer),
  quotationV2: persistReducer(quotationV2ReducerConfig, quotationV2Reducer),
  audit: auditReducer,
  product: persistReducer(productReducerConfig, productReducer),
  gallery: galleryReducer,
  productPartDetails: productPartDetails,
  user: userReducer,
  listing: persistReducer(listingsConfig, listingReducer),
  listingBundle: listingBundleReducer,
  category: categoryReducer,
  manufacturer: manufacturerReducer,
  transaction: transactionReducer,
  transactionPayment: transactionPaymentReducer,
  app: persistReducer(appConfig, appReducer),
  flashDeals: flashDealsReducer,
  sales: persistReducer(salesConfig, salesReducer),
  rma: persistReducer(rmaConfig, rmaReducer),
  rmaInventory: rmaInventoryReducer,
  role: roleReducer,
  permission: permissionReducer,
  sms: smsReducer,
  inventory: inventoryReducer,
  pcPackage: pcPackageReducer,
  branches: branchesReducer,
  options: optionReducer,
  raffle: persistReducer(raffleConfig, raffleReducer),
  pcwUser: persistReducer(pcwUserConfig, pcwUserReducer),
  // pcwUser: pcwUserReducer,

  // ecomm
  ecomOrders: ecomOrdersReducer,
  banner: bannerReducer,
  kachiPoints: kachiPointsReducer,
  userBuilds: userBuildsReducer,

  //transfer stock
  transferStock: TransferStockReducer,

  //blogs
  blogs: blogsReducer,
  blogCategory: blogCategoryReducer,

  // inventory audit
  inventoryAudit: persistReducer(inventoryAuditConfig, inventoryAuditReducer),

  //pc bundles
  pcBundles: pcBundlesReducer,

  taptapCustomer: persistReducer(taptapCustomerConfig, taptapCustomerReducer),
  location: locationreducer,
  //promotional
  promotional: promotionalReducer,

  //favorites
  favoriteModules: persistReducer(favoriteModuleConfig, favoriteReducer),

  // Recent Visit Modules
  recentViewModules: persistReducer(
    recentlyViewedConfig,
    recentViewedModuleReducer
  ),

  fastMovingProducts: persistReducer(
    fastMovingProductConfig,
    fastMovingProductReducer
  ),

  purchaseOrder: purchaseOrderReducer,

  taxCertificate: taxCertificateReducer,

  //voucher
  voucher: voucherReducer,

  //sell out
  sellOut: sellOutReducer,

  // Payment Types
  paymentTypes: paymentTypeReducer,

  //cheque management
  chequeMangement: persistReducer(
    chequeManagementConfig,
    chequeManagementReducer
  ),

  eventSubcriptions: eventSubscriptionsReducer,

  // emailer
  emailer: emailerReducer,

  // customer payment
  customerPayment: customerPaymentReducer,

  // last route
  lastRoute: persistReducer(lastRouteConfig, lastRouteReducer),

  //crm-sales
  crmSales: crmSalesReducer
});
